import { axiosInstance } from "@/plugins/axios";

export default {
  namespaced: true,
  state: {
    blogCategories: {},
    isHighlight: false,
    post: {},
    categoriesWithPosts: {},
    isPremium: false,
  },
  getters: {
    blogCategories(state) {
      return state.blogCategories;
    },
    isHighlight(state) {
      return state.isHighlight;
    },
    post(state) {
      return state.post;
    },
    categoriesWithPosts(state) {
      return state.categoriesWithPosts;
    },
    isPremium(state) {
      return state.isPremium;
    },
  },
  mutations: {
    SET_BLOG_CATEGORIES(state, value) {
      state.blogCategories = value;
    },
    SET_IS_HIGHLIGHT(state, value) {
      state.isHighlight = value;
    },
    SET_POST(state, value) {
      state.post = value;
    },
    SET_CATEGORIES_WITH_POSTS(state, value) {
      state.categoriesWithPosts = value;
    },
    SET_IS_PREMIUM(state, value) {
      state.isPremium = value;
    },
  },
  actions: {
    async registerCategoryBlog(context, value) {
      console.log("VALUE", value);
      let formData = new FormData();
      formData.append("id_user", value.id_user);
      formData.append("name", value.name);
      formData.append("picture", value.picture);

      const url = value.id ? `blog/categories/${value.id}` : "blog/categories";

      await axiosInstance({
        method: "POST",
        url: url,
        data: formData,
      })
        .then((response) => response.data)
        .then(() => {
          context.dispatch("consultCategoriesBlog");
        });
    },
    async consultCategoriesBlog(context) {
      await axiosInstance({
        method: "GET",
        url: "blog/categories",
      })
        .then((response) => response.data)
        .then((data) => {
          context.dispatch("setDataDefault", ["SET_BLOG_CATEGORIES", data]);
        });
    },
    async consultCategoriesBlogNoImage(context) {
      await axiosInstance({
        method: "GET",
        url: "blog/categories/no-image",
      })
        .then((response) => response.data)
        .then((data) => {
          context.dispatch("setDataDefault", ["SET_BLOG_CATEGORIES", data]);
        });
    },
    async removeCategoryBlog(context, id) {
      await axiosInstance({
        method: "DELETE",
        url: `blog/categories/${id}`,
      })
        .then((response) => response.data)
        .then(() => {
          context.dispatch("consultCategoriesBlog");
        });
    },
    async registerPost(context, value) {
      let formData = new FormData();
      formData.append("id_user", value.id_user);
      formData.append("id_blog_category", value.id_blog_category);
      formData.append("title_description", value.title_description);
      formData.append("text_description", value.text_description);
      formData.append("contentHtml", value.contentHtml);
      formData.append("is_highlight", value.is_highlight);
      formData.append("is_premium", value.is_premium);
      formData.append("picture", value.picture);
      formData.append("picture_file_name", value.picture_file_name);
      formData.append("picture_file_path", value.picture_file_path);

      const url = value?.id_post ? `blog/posts/${value.id_post}` : "blog/posts";

      await axiosInstance({
        method: "POST",
        url: url,
        data: formData,
      })
        .then((response) => response.data)
        .then(() => {
          let obj;
          if (value?.id_post) {
            obj = { id_category: value.id_category, id_post: value.id_post };
          }
          context.dispatch("consultCategoriesWithPosts", obj);
        });
    },
    async consultPosts(context) {
      await axiosInstance({
        method: "GET",
        url: "blog/posts",
      })
        .then((response) => response.data)
        .then((data) => {
          context.dispatch("setDataDefault", ["SET_POST", data]);
        });
    },
    async consultCategoriesWithPosts(context, value) {
      const url =
        value?.id_category && value?.id_post
          ? `blog/categories/${value.id_category}/posts/${value.id_post}`
          : value?.id_category
          ? `blog/categories/${value.id_category}/posts`
          : "blog/categories/posts";

      await axiosInstance({
        method: "GET",
        url: url,
      })
        .then((response) => response.data)
        .then((data) => {
          context.dispatch("setDataDefault", [
            "SET_CATEGORIES_WITH_POSTS",
            data,
          ]);
        });
    },
    async removePost(context, id) {
      await axiosInstance({
        method: "DELETE",
        url: `blog/posts/${id}`,
      })
        .then((response) => response.data)
        .then((data) => {
          context.dispatch("setDataDefault", ["SET_BLOG_CATEGORIES", data]);
        });
    },
    setDataDefault(context, [mutationName, value]) {
      context.commit(`${mutationName}`, value);
    },
  },
};
